import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import GrainOverlay from "@/components/GrainOverlay";
import { Toaster } from "sonner";

export const Layout = ({ children }) => (
  <>
    <GrainOverlay />
    <Navbar />
    <main>{children}</main>
    <Footer />
    <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#12141A", border: "1px solid rgba(255,255,255,0.1)", color: "#fff", borderRadius: 0, fontFamily: "Manrope, sans-serif" } }} />
  </>
);

export default Layout;
